export function PauseIcon() {
  return (
    <path fill="currentColor" d="M14 19V5h4v14zm-8 0V5h4v14z"></path>
  )
}